import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { tasksId } from "../../../types/activityTasks";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { PanelInstrucionHands } from "../../../components/common/PanelInstrucionHands";
import { imgInstruction } from "../../../assets/imgIntruction";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { TimerSubOneActFour } from "../../../components/tema1/TimerSubOneActFour";
import { audiosAssets } from "../../../assets/audio";
import { DialogActivities } from "../../../components/common/DialogActivities";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";


const steps = {
	initialDialog: 1,
	viewActivities: 10,
	insrucctions: 2,
	instructionsone: 4,
	game: 1000,
	winSubactivityFour: 8,
	FailSubactivityFour: 9,
};

export const SubtopicOneActivityFour = () => {
	const dispatch = useDispatch();
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(steps.initialDialog);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema1.activities.subtema1], 4);

	useEffect(() => {
		if (loaded) {
			console.log("subtema one Activity one");
			ObserverEmitter.emit(EVENTS.subtopicOne.initScene, 4);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.cityScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub01.sub1_act4_a01)
	})

	ObserverEmitter.on(EVENTS.subtopicOne.activityThree.openModalOxxo, () => {
		ObserverEmitter.emit(EVENTS.subtopicOne.activityThree.openClock, false)
		setUiToShow(steps.winSubactivityFour)
	})


	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, steps.game].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.subtopicOne.initScene, 4);
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === steps.initialDialog && (
				<>
					<HeaderRedPresentation name="Actividad 1: Tipos de tienda." />
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={
							"¡Muy bien! Ahora tomémonos un tiempo para divertirnos. Recorre la ciudad y encuentra el tipo de tienda que te corresponde y presiona sobre ella, pero date prisa, porque sólo tienes 1 minuto."
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.viewActivities);
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
						}}
						percentage={"50%"}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.viewActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 1: Imagen en la tienda."
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							setUiToShow(steps.insrucctions);
						}}
						activities={tasksList}
					/>
				</>
			)}
			{uiToShow === steps.insrucctions && (
				<>
					<PanelInstrucionHands
						text="Toca encima de el piso para trasladarte al área seleccionada."
						action={() => {
							setUiToShow(steps.instructionsone);
						}}
						img={imgInstruction.sub1_act_3_01}
					/>
				</>
			)}
			{uiToShow === steps.instructionsone && (
				<>
					<PanelInstrucionHands
						text="Toca y arrastra con tu dedo para girar la vista."
						action={() => {
							setUiToShow(steps.game);
							ObserverEmitter.emit(EVENTS.subtopicOne.activityThree.initActivityMovement);
						}}
						img={imgInstruction.sub1_act_3_02}
					/>
				</>
			)}
			{uiToShow === steps.game && (
				<>
					<TimerSubOneActFour action={() => {
						setUiToShow(steps.FailSubactivityFour)
					}} />
					<DialogActivities
						dialog={
							"¡Muy bien! Ahora tomémonos un tiempo para divertirnos. Recorre la ciudad y encuentra el tipo de tienda que te corresponde y presiona sobre ella, pero date prisa, porque sólo tienes 1 minuto."
						}
						percentage={"50%"}
					/>
				</>
			)}

			{uiToShow === steps.winSubactivityFour && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={5}
						dialogModal="¡Increíble! Venciste al reloj y localizaste tu tipo de tienda."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 4,
									pointsWin: 5,
									subtema: tasksId.tema1.activities.subtema1,
								})
							);
							// navigate("/home1/tema1/subtema1/activityfive");
							window.location.href = "/home1/tema1/subtema1/activityfive"
						}}
					/>
				</>
			)}

			{uiToShow === steps.FailSubactivityFour && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ValidationResultModal
						title="Respuesta incorrecta."
						dialogModal="Estuviste cerca, lamentablemente el tiempo nos ganó, tal vez tengamos mejor suerte para la próxima."
						buttonTxt="Continuar"
						isCorrect={false}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 4,
									pointsWin: 5,
									subtema: tasksId.tema1.activities.subtema1,
								})
							);
							// navigate("/home1/tema1/subtema1/activityfive");
							window.location.href = "/home1/tema1/subtema1/activityfive"
						}}
					/>
				</>
			)}
		</>
	);
};
